import { render, staticRenderFns } from "./ModuleActionsForm.vue?vue&type=template&id=09d06bba"
import script from "./ModuleActionsForm.vue?vue&type=script&lang=js"
export * from "./ModuleActionsForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleActionsForm.vue?vue&type=style&index=0&id=09d06bba&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports